/**
 * @generated SignedSource<<5a413d9376dbff100aa1acd7df55a5b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarSidemarkPane_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarSidemarkForm_viewer">;
  readonly " $fragmentType": "CheckoutSidebarSidemarkPane_viewer";
};
export type CheckoutSidebarSidemarkPane_viewer$key = {
  readonly " $data"?: CheckoutSidebarSidemarkPane_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarSidemarkPane_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarSidemarkPane_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarSidemarkForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "73392e176d48291563da5183417a8174";

export default node;
